import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { MergefieldDetailSection } from "../MergefieldDetailSection";
import React from "react";
import { useLoaderData } from "react-router";

const MergefieldsApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MergeFieldsListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <MergefieldDetailSection
        pageTitle={viewModel.pageTitle}
        availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}

export default MergefieldsApp;